import React from "react";
import { Box } from '@mui/joy';
import { Bar } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import { useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import CostiAnalisiKPISet from "../costiAnalisi/CostiAnalisi.KPISet";
import JSONPretty from 'react-json-pretty'

const CostiTimeline = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);

    const showKPI = true;
    const showTimelineCost = true;

    const createTimelineBarFilterHandler = (field, addFilter) => (params) => {
        const [monthStr, yearStr] = params.split(' ');
        const month = parseInt(monthStr, 10) - 1;
        const year = parseInt(yearStr, 10);

        const start = new Date(year, month, 1);
        const end = new Date(year, month + 1, 0);

        addFilter(field, params);
    };

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Costs')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <CostiAnalisiKPISet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showTimelineCost &&
                <Box className="report-itemgroup report-itemgroup-timeline" sx={{ marginTop: '10px', marginBottom: '30px' }}>
                    <Box className="report-item">
                        {/* <JSONPretty data={filters} className="json-wrapper" /> */}
                        <Bar
                            title={t("Costi per mese per area")}
                            dataProviderName="statisticsviews/costsbymonth/timelinedfinancial/views_advertisings_advertisingcost/registered_at/month/value/_related_area_name"
                            filters={filters}
                            handleFilterChange={createTimelineBarFilterHandler('registered_at', addFilter)}
                            showTooltip={true}
                            format={'currency'}
                        />
                        <Bar
                            title={t("Costi per mese per fonte")}
                            dataProviderName="statisticsviews/costsbymonth/timelinedfinancial/views_advertisings_advertisingcost/registered_at/month/value/_related_source_name"
                            filters={filters}
                            handleFilterChange={createTimelineBarFilterHandler('registered_at', addFilter)}
                            showTooltip={true}
                            format={'currency'}
                        />
                    </Box>
                </Box>
            }
        </Box>
    )
}

export default CostiTimeline;
